import { render } from "./CreateAttachment.vue?vue&type=template&id=3c212e74"
import script from "./CreateAttachment.vue?vue&type=script&lang=js"
export * from "./CreateAttachment.vue?vue&type=script&lang=js"

import "./CreateAttachment.vue?vue&type=style&index=0&id=3c212e74&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__